import { useEffect, useState, useCallback } from "react";
import { FiTrash2, FiPlus, FiEdit2 } from "react-icons/fi";
import AdminLayout from "../../components/layout/AdminLayout";
import { useAuth } from "../../context/AuthContext";
import FormDataKelas from "./FormDataKelas";
import ConfirmDeleteModal from "../../components/modal/Delete";
import { toast } from "react-toastify";
import axios from "axios";

export default function DataKelas() {
  const { token } = useAuth();
  const [kelas, setKelas] = useState([]);
  const [filteredKelas, setFilteredKelas] = useState([]);
  const [search, setSearch] = useState("");
  const [filterTingkat, setFilterTingkat] = useState("");
  const [loading, setLoading] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [openForm, setOpenForm] = useState(false);
  const [selectedKelas, setSelectedKelas] = useState(null);

  const fetchKelas = useCallback(async () => {
    try {
      setLoading(true);
      const res = await axios.get("https://backend.smpn1kamal.sch.id/api/kelas", {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = res.data.data || res.data;
      setKelas(data);
      setFilteredKelas(data);
    } catch {
      toast.error("Gagal mengambil data kelas");
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => { fetchKelas(); }, [fetchKelas]);

  useEffect(() => {
    let data = [...kelas];
    if (filterTingkat) data = data.filter((k) => k.nama_kelas?.startsWith(filterTingkat));
    if (search) {
      const keyword = search.toLowerCase();
      data = data.filter((k) =>
        k.nama_kelas?.toLowerCase().includes(keyword) ||
        k.wali_kelas?.toLowerCase().includes(keyword)
      );
    }
    setFilteredKelas(data);
  }, [kelas, search, filterTingkat]);

  const confirmDelete = async () => {
    setIsDeleting(true);
    try {
      await axios.delete(`https://backend.smpn1kamal.sch.id/api/kelas/${deleteId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success("Data kelas berhasil dihapus");
      fetchKelas();
      setIsDeleteModalOpen(false);
    } catch {
      toast.error("Gagal menghapus data kelas");
    } finally {
      setIsDeleting(false);
      setDeleteId(null);
    }
  };

  return (
    <AdminLayout>
      <div className="space-y-6">

        {/* HEADER */}
        <div className="space-y-3">
          <div className="hidden md:flex justify-between items-center">
            <div>
              <h1 className="text-2xl font-bold text-indigo-600">Data Kelas</h1>
              <p className="text-sm text-gray-500">SMPN 1 Kamal</p>
            </div>
            <button
              onClick={() => { setSelectedKelas(null); setOpenForm(true); }}
              className="flex items-center gap-2 bg-indigo-500 text-white px-5 py-2 rounded-full hover:bg-indigo-600 transition shadow-sm"
            >
              <FiPlus /> Tambah
            </button>
          </div>
          <div className="md:hidden space-y-3">
            <div className="flex justify-between items-center">
              <div>
                <h1 className="text-2xl font-bold text-indigo-600">Data Kelas</h1>
                <p className="text-sm text-gray-500">SMPN 1 Kamal</p>
              </div>
              <button
                onClick={() => { setSelectedKelas(null); setOpenForm(true); }}
                className="flex items-center gap-2 bg-indigo-500 text-white px-4 py-2 rounded-full hover:bg-indigo-600 transition shadow-sm text-sm"
              >
                <FiPlus /> Tambah
              </button>
            </div>
          </div>
        </div>

        {/* CARD */}
        <div className="bg-white rounded-2xl shadow-md p-5">
          <div className="flex flex-row items-center justify-between gap-3 mb-5">
            <select
              value={filterTingkat}
              onChange={(e) => setFilterTingkat(e.target.value)}
              className="border border-slate-300 rounded-full px-3 py-2 text-xs md:text-sm"
            >
              <option value="">Semua Tingkat</option>
              <option value="7">Kelas 7</option>
              <option value="8">Kelas 8</option>
              <option value="9">Kelas 9</option>
            </select>
            <input
              type="text"
              placeholder="Cari..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="border border-slate-300 rounded-full px-3 py-2 text-xs md:text-sm w-40 md:w-72"
            />
          </div>

          {loading ? (
            <div className="flex flex-col items-center py-12">
              <div className="w-8 h-8 border-4 border-indigo-200 border-t-indigo-600 rounded-full animate-spin mb-2" />
              <p className="text-gray-400 text-sm">Memuat data...</p>
            </div>
          ) : (
            <>
              {/* MOBILE */}
              <div className="md:hidden space-y-4">
                {filteredKelas.length === 0 ? (
                  <p className="text-center py-4 text-gray-400">Data tidak ditemukan</p>
                ) : (
                  filteredKelas.map((k) => (
                    <div key={k.id_kelas} className="border rounded-xl p-4 shadow-sm">
                      <p className="font-semibold">{k.nama_kelas}</p>
                      <p className="text-sm text-gray-500">Wali: {k.wali_kelas || "-"}</p>
                      <p className="text-sm text-gray-500">{k.jumlah_siswa} Siswa</p>
                      <div className="flex gap-2 mt-3">
                        <button
                          onClick={() => { setSelectedKelas(k); setOpenForm(true); }}
                          className="flex-1 flex items-center justify-center gap-1.5 bg-blue-50 text-blue-600 py-2 rounded-full text-sm hover:bg-blue-100 transition"
                        >
                          <FiEdit2 size={13} /> Edit
                        </button>
                        <button
                          onClick={() => { setDeleteId(k.id_kelas); setIsDeleteModalOpen(true); }}
                          className="flex-1 flex items-center justify-center gap-1.5 bg-red-50 text-red-500 py-2 rounded-full text-sm hover:bg-red-100 transition"
                        >
                          <FiTrash2 size={13} /> Hapus
                        </button>
                      </div>
                    </div>
                  ))
                )}
              </div>

              {/* DESKTOP */}
              <div className="hidden md:block overflow-x-auto">
                <table className="w-full text-sm">
                  <thead className="bg-gray-100 text-gray-600">
                    <tr>
                      <th className="px-4 py-3 text-left">NO</th>
                      <th className="px-4 py-3 text-left">NAMA KELAS</th>
                      <th className="px-4 py-3 text-left">JUMLAH SISWA</th>
                      <th className="px-4 py-3 text-left">WALI KELAS</th>
                      <th className="px-4 py-3 text-center">AKSI</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredKelas.length === 0 ? (
                      <tr>
                        <td colSpan="5" className="text-center py-10 text-gray-400">
                          Tidak ada data kelas tersedia.
                        </td>
                      </tr>
                    ) : (
                      filteredKelas.map((k, i) => (
                        <tr key={k.id_kelas} className="border-t hover:bg-gray-50">
                          <td className="px-4 py-3">{i + 1}</td>
                          <td className="px-4 py-3 font-medium">{k.nama_kelas}</td>
                          <td className="px-4 py-3">{k.jumlah_siswa} Siswa</td>
                          <td className="px-4 py-3">{k.wali_kelas || "-"}</td>
                          <td className="px-4 py-3">
                            <div className="flex justify-center gap-2">
                              <button
                                onClick={() => { setSelectedKelas(k); setOpenForm(true); }}
                                className="w-8 h-8 flex items-center justify-center rounded-full bg-blue-50 text-blue-600 hover:bg-blue-100 transition"
                              >
                                <FiEdit2 size={13} />
                              </button>
                              <button
                                onClick={() => { setDeleteId(k.id_kelas); setIsDeleteModalOpen(true); }}
                                className="w-8 h-8 flex items-center justify-center rounded-full bg-red-50 text-red-500 hover:bg-red-100 transition"
                              >
                                <FiTrash2 size={13} />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>

        <FormDataKelas
          open={openForm}
          onClose={() => setOpenForm(false)}
          onSuccess={fetchKelas}
          data={selectedKelas}
        />
        <ConfirmDeleteModal
          open={isDeleteModalOpen}
          onClose={() => setIsDeleteModalOpen(false)}
          onConfirm={confirmDelete}
          loading={isDeleting}
          title="Hapus Data Kelas"
          description="Apakah Anda yakin ingin menghapus data kelas ini? Seluruh data yang terkait mungkin akan terpengaruh."
        />
      </div>
    </AdminLayout>
  );
}